export { default } from './FullscreenControl';
